import React from "react";
import { Component } from "react";
// import swal from "sweetalert";
// import api from "utils/api";
import utils from "utils";
import jwt_decode from "jwt-decode";
import Loader from "Components/Loader";;
import { PRIMARY_LANG,ORG_ID } from "Common/constant";
import {
  Button,
  Col,
  Descriptions,
  Divider,
  Modal,
  Result,
  Row,
  Space,
  Typography,
} from "antd";
import { PYMT_CODE_DETAILS } from "Common/constant";
import api from "utils/api";
import { CONSTANTS } from "utils/constant";
import { withTranslation } from "react-i18next";
import PaymentSuccess from "Pages/Assessment/PaidAssessment/PaymentSuccess";
import { connect,  } from "react-redux";
import { setHeadingQuestionType } from "store/slice/assessment-slice";
import { LANG_STYLD_EXT } from "Common/constant";
class PaymentViewAssessment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      txnNo: null,
      status: null,
      amount: null,
      title: null,
      plan: null,
      txnDate: null,
      pymtMethod: null,
      stsDesc: null,
      is_success:false,
      redirectPath: "/logged-in-user/dashboard",
      isLoading : false,
    };
  }

  displayBillDeskPay = (paymentData) => {
    const {t} = this.props;
    let flow_config = {
      merchantId: paymentData?.billDeskData?.order_data?.merc_id,
      bdOrderId: paymentData?.billDeskData?.order_data?.bd_order_id,
      authToken: paymentData?.billDeskData?.order_data?.auth_token,
      childWindow: true,
      retryCount: 3,
      prefs: {
        payment_categories: paymentData?.billDeskData?.order_data?.payment_categories  || ["card", "nb"],
      },
    };

    let responseHandler = function (txn) {
      //loader
      this.setState({isLoading : true, isModalOpen: true,})
      if (txn?.txnResponse?.transaction_response) {
        let data = {
          order_number:
            this.props.location.paymentData?.billDeskData?.order_data
              ?.order_number,
        };        
        api
          .get_payment_status(data)
          .then((res) => {
            if(res.data.status == 200){
            // let { transaction_dict } = res.data.data;
            let { transaction_details,order_details,plan_details } = res.data.data;
            let obj = PYMT_CODE_DETAILS.find(
              (item) => item.code === transaction_details.auth_status
            );
            setTimeout(() => {
              this.setState({
                isLoading : false,
                isModalOpen: true,
                txnNo: transaction_details.transaction_id,
                status: obj.status,
                amount: order_details.order_amount,
                title: obj.msg,
                plan: plan_details.plan_name,
                txnDate: transaction_details.transaction_date,
                pymtMethod: "Online Payment",
                redirectPath: obj.redirectPath,
                stsDesc:
                        transaction_details.auth_status === "0399"
                        ? transaction_details.transaction_message
                        : null,
                is_success:transaction_details.auth_status === "0300"      
              });
            }, 1000);
          }
          })
          .catch((err) => {
            this.setState({isLoading : false})
            console.log(`${t(CONSTANTS.ERROR_IN_PAYMENT, { lng: PRIMARY_LANG })}`);
          });
      } else {
        let data = {
          order_id: this.props.location.paymentData.subscriptionid,
        };
        api
          .terminate_payment(data)
          .then((res) => {})
          .catch((err) => {
            console.log(`${t(CONSTANTS.PAYMENT_TERMINATE, { lng: PRIMARY_LANG })}`);
          })
          .finally(() => {
            this.handleBackPath();
          //   this.props.history.push({
          //     pathname: `/logged-in-user/coupon-apply`,
          //   });
          });
      }

      // api
      //     .payment_status({"order_id" :paymentData?.billDeskData?.order_data?.orderid || ""})
      //     .then((response) => {
      //       if (response.data?.data?.order_data?.payment_status) {
      //         let subscription =
      //           localStorage.getItem("subscription") === null
      //             ? {}
      //             : JSON.parse(localStorage.getItem("subscription"));
      //         let output = {
      //           ...subscription,
      //           ...response.data?.data?.membership_data,
      //         };
      //         localStorage.setItem("subscription", JSON.stringify(output));
      //         setTimeout(() => {
      //           swal(response.data.message || "Plan Subscribed Successfully!", {
      //             button: false,
      //           });
      //           location.pathname ="logged-in-user/dashboard";
      //         }, 1000);
      //       } else {
      //         swal(response.data.message || "Error during Subscription", { button: false });
      //         setTimeout(() => {
      //           location.pathname = "logged-in-user/subscription-plan";
      //         }, 1000);
      //       }
      //     })
      //     .catch((error) => {
      //       swal("Error during Subscription", { button: false });
      //       setTimeout(() => {
      //         location.pathname = "logged-in-user/subscription-plan";
      //       }, 1000);
      //     });
      // setTimeout(() => {
      //   swal("Plan Subscribed Successfully!", {
      //     button: false,
      //   });
      //   location.pathname = paymentData.baseUrl + "/dashboard";
      // }, 1000);
    };    
    // let merchantLogo ="https://uploads-ssl.webflow.com/62e111392a1b386cab8f3bcf/62ea3680fb5c9e1e165ad993_niyama%20footer.svg"
     let merchantLogo = "https://d1uansy8sat5xb.cloudfront.net/Ziloy%20Logo%20(final).svg"
    if(this.props.location?.user_details?.org_name){
      merchantLogo = ORG_ID[this.props.location?.user_details?.org_name] ? ORG_ID[this.props.location?.user_details?.org_name]?.full_logo : merchantLogo
    }
    let config = {
      responseHandler: responseHandler.bind(this),
      merchantLogo,
      flowConfig: flow_config,
      flowType: "payments",
    };

    window.loadBillDeskSdk(config);
  };

  handleGoBack() {
    this.setState({ isModalOpen: false });
    this.props.history.push({
      pathname: this.state.redirectPath,
    });
  }

  handleRetryPayment() {
    this.setState({ isModalOpen: false });
    // this.props.history.push({
    //   pathname: `/logged-in-user/coupon-apply`,
    // });
    this.handleBackPath();
  }
  handleBackPath(){
    const{assessment_id} =this.props.score_details;
    if(assessment_id){          
        this.props.history.push({
            pathname: `/logged-in-user/payment-detail`,
            // state: {
            //   data:{ plan_id:serviceid,
            //     type,
            //     assessment_id,score_details}
            // },
        });            
    }
    else{
    this.props.history.push({
      pathname: `/logged-in-user/coupon-apply`,
    });
  }
}
  componentDidMount = () => {
    let { paymentData } = this.props.location || {};
    if (paymentData != undefined) {
      this.displayBillDeskPay(paymentData);
    } else {
      this.props.history.push({
        pathname: `/logged-in-user/dashboard`,
      });
    }
  };

  render() {
     const {t} = this.props;
        const tgtLang = this.props.includePrimeLang
        ? this.props.i18n.language + "_" + PRIMARY_LANG
        : this.props.i18n.language;
        const tgtLangST = this.props.includePrimeLang
        ? tgtLang + LANG_STYLD_EXT
        : tgtLang; 
    const{assessment_id} =this.props.score_details;
    return (
      <div className="apps">
        <Modal
          open={this.state.isModalOpen}
          footer={null}
          closable={false}
          centered
        >
        <>
        {this.state.isLoading ? <Loader /> :
        <>{(assessment_id && this.state.is_success)?<PaymentSuccess tgtLangST={tgtLangST} t={t} assessment_details={this.props.assessment_details}
          score_details={this.props.score_details}
          planDetails={this.props.planDetails} paymentData={this.props.location.paymentData}setHeadingQuestionType={this.props.setHeadingQuestionType} txnDate={this.state.txnDate}/>:
          <Result
            status={this.state.status}
            title={this.state.title}
            subTitle={
              <>
                <Row justify="center">
                  <Typography.Paragraph>
                    {t(CONSTANTS.TRANSACTION_NUMBER, { lng: PRIMARY_LANG })}
                  </Typography.Paragraph>
                  &nbsp;
                  <Typography.Paragraph copyable>
                    {this.state.txnNo}
                  </Typography.Paragraph>
                </Row>
                <Divider style={{ margin: 0 }} />
              </>
            }
          >
            <Row gutter={[0, 16]}>
              <Col span={24} 
               className="payment-description">
                <Descriptions
                  layout="horizontal"
                  bordered
                  column={1}
                  size="middle"
                  labelStyle={{ width: "40%" }}
                >
                  <Descriptions.Item label={t(CONSTANTS.AMOUNT, { lng: PRIMARY_LANG })}>
                    AED {this.state.amount}
                  </Descriptions.Item>
                  <Descriptions.Item label={t(CONSTANTS.MEMBERSHIP_PLAN, { lng: PRIMARY_LANG })}>
                    {this.state.plan}
                  </Descriptions.Item>
                  <Descriptions.Item label={t(CONSTANTS.DATE_AND_TIME, { lng: PRIMARY_LANG })}>
                    {utils.FormatDate(this.state.txnDate, "DATE_TIME_3")}
                  </Descriptions.Item>
                  <Descriptions.Item label={t(CONSTANTS.PAYMENT_MODE, { lng: PRIMARY_LANG })}>
                    {utils.Capitalize(this.state.pymtMethod)}
                  </Descriptions.Item>
                  {this.state.stsDesc && (
                    <Descriptions.Item label={t(CONSTANTS.STATUS_DESCRIPTION, { lng: PRIMARY_LANG })}>
                      {this.state.stsDesc}
                    </Descriptions.Item>
                  )}
                </Descriptions>
              </Col>
              <Col span={24} align="center">
                <Space>
                  <Button
                    type="primary"
                    key="console"
                    onClick={this.handleGoBack.bind(this)}
                  >
                    {t(CONSTANTS.CONTINUE, { lng: PRIMARY_LANG })}
                  </Button>
                  {this.state.status === "error" && (
                    <Button
                      key="retry"
                      onClick={this.handleRetryPayment.bind(this)}
                    >
                      {t(CONSTANTS.RETRY_PAYMENT, { lng: PRIMARY_LANG })}
                    </Button>
                  )}
                </Space>
              </Col>
            </Row>
          </Result>
        }
          </>
        }
        </>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user_details: state.loginReducer.user_details,
    includePrimeLang: state.loginReducer.includePrimeLang,
    assessment_details:state.paidAssessmentReducer.assessment_details,
    score_details:state.paidAssessmentReducer.score_details,
    planDetails:state.paidAssessmentReducer.plan_details,
  };
};
const mapDispatchToProps = {
  setHeadingQuestionType
};
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PaymentViewAssessment));
